import styled from "styled-components";
import { Cell } from "@vds/tables";
import { device } from "./breakpoints";

// ─── Sites Table Columns ────────────────────────────────────────────────────

export const SiteNameCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  width: 100%;
  vertical-align: middle;
`;

export const SiteNameText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

export const TruncatedSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
  vertical-align: bottom;
`;

// ─── Add User Table ──────────────────────────────────────────────────────────

export const ResponsiveTableWrapper = styled.div`
  /* Mobile-first: let table adapt to container width */
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  /* No min-width on mobile - let table fit naturally */
  table {
    width: 100%;
    table-layout: auto;
  }

  @media ${device.tablet} {
    table {
      min-width: 600px;
    }
  }

  @media ${device.desktop} {
    overflow-x: visible;
    table {
      min-width: auto;
    }
  }
`;

export const FlexContainer = styled.div`
  /* Mobile-first: flexible container for checkbox + name */
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 5px;
  min-width: 0; /* Allow text truncation */

  @media ${device.tablet} {
    gap: 15px;
  }
`;

export const UserNameCell = styled(Cell)`
  /* Mobile-first: compact user name display */
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 120px;

  @media ${device.tablet} {
    font-size: 14px;
    line-height: 1.5;
    min-width: 150px;
  }

  @media ${device.desktop} {
    font-size: 16px;
    min-width: auto;
    white-space: normal;
  }
`;

export const EmailCell = styled(Cell)`
  /* Mobile-first: proper text handling for long emails */
  word-break: break-word;
  overflow-wrap: break-word;
  font-size: 12px;
  line-height: 1.3;

  /* Allow email column to be flexible on mobile */
  max-width: none;
  width: auto;

  @media ${device.tablet} {
    font-size: 14px;
    line-height: 1.5;
  }

  @media ${device.desktop} {
    font-size: 16px;
  }
`;
